import React from 'react';

import {SvgIcon} from './SvgIcon';

export const SuperCoachIcon: SvgIcon = ({
  width = 32,
  height = 32,
  classes = 'text-white',
}) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 32 32"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={classes}
  >
    <rect width="32" height="32" rx="9.26316" className="fill-current" />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M21.0525 9.28125C22.4477 9.28125 23.5788 10.4123 23.5788 11.8076V18.4069C23.5788 19.5327 22.6661 20.4454 21.5403 20.4454H21.4793C20.7624 20.4454 20.1813 21.0265 20.1813 21.7433C20.1813 22.5812 19.1933 23.0276 18.5645 22.4739L16.7384 20.8657C16.4309 20.5948 16.0351 20.4454 15.6253 20.4454H10.9472C9.55197 20.4454 8.4209 19.3143 8.4209 17.9191V11.8076C8.4209 10.4123 9.55197 9.28125 10.9472 9.28125H21.0525ZM20.3847 13.3956C20.7136 13.0668 20.7136 12.5336 20.3847 12.2047C20.0558 11.8758 19.5226 11.8758 19.1938 12.2047L15.4584 15.9401L14.1591 14.6408C13.8303 14.3119 13.2971 14.3119 12.9682 14.6408C12.6394 14.9697 12.6394 15.5028 12.9682 15.8317L14.863 17.7264L15.4584 18.3219L16.0539 17.7264L20.3847 13.3956Z"
      fill="url(#paint0_linear_9704_700)"
    />
    <defs>
      <linearGradient
        id="paint0_linear_9704_700"
        x1="15.9998"
        y1="9.28125"
        x2="10.4588"
        y2="24.5893"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="black" stopOpacity="1" />
        <stop offset="1" stopColor="#EAEFFD" stopOpacity="1" />
      </linearGradient>
    </defs>
  </svg>
);

export const SuperCoachUpgradeIcon: SvgIcon = ({
  width = 28,
  height = 28,
  classes = 'text-white',
}) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 28 28"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={classes}
  >
    <rect width={28} height={28} rx="7" fill="#E1F1F2" />
    <path
      d="M21.7002 5.1875C22.8599 5.18761 23.7998 6.12738 23.7998 7.28711V17.5234C23.7995 18.683 22.8597 19.6229 21.7002 19.623H20.8066C20.0336 19.6232 19.4072 20.2503 19.4072 21.0234V21.7637C19.4069 22.6671 18.3412 23.148 17.6631 22.5508L14.7344 19.9727C14.4788 19.7476 14.1501 19.6231 13.8096 19.623H6.2998C5.14026 19.6229 4.20045 18.683 4.2002 17.5234V7.28711C4.2002 6.12738 5.1401 5.18761 6.2998 5.1875H21.7002ZM14.6699 8.52148C14.4591 7.89282 13.5409 7.89282 13.3301 8.52148L12.6562 10.5322C12.5619 10.8132 12.2913 11.0039 11.9863 11.0039H9.80566C9.12359 11.0039 8.83979 11.8497 9.3916 12.2383L11.1562 13.4805C11.403 13.6542 11.5063 13.9621 11.4121 14.2432L10.7383 16.2539C10.5276 16.8825 11.2695 17.4049 11.8213 17.0166L13.5859 15.7744C13.8327 15.6007 14.1673 15.6007 14.4141 15.7744L16.1787 17.0166C16.7305 17.4049 17.4724 16.8825 17.2617 16.2539L16.5879 14.2432C16.4937 13.9621 16.597 13.6542 16.8438 13.4805L18.6084 12.2383C19.1602 11.8497 18.8764 11.0039 18.1943 11.0039H16.0137C15.7087 11.0039 15.4381 10.8132 15.3438 10.5322L14.6699 8.52148Z"
      fill="url(#paint0_linear_12787_5222)"
    />
    <defs>
      <linearGradient
        id="paint0_linear_12787_5222"
        x1="14"
        y1="5.1875"
        x2="6.65043"
        y2="25.201"
        gradientUnits="userSpaceOnUse"
      >
        <stop />
        <stop offset="1" stopColor="#EBEFFC" />
      </linearGradient>
    </defs>
  </svg>
);

export const CoachSmartMoodIcon: SvgIcon = ({width = 26, height = 26}) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 26 26"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M13 2C19.0751 2 24 6.92487 24 13C24 19.0751 19.0751 24 13 24C6.92487 24 2 19.0751 2 13C2 6.92487 6.92487 2 13 2ZM13 4C8.02944 4 4 8.02944 4 13C4 17.9706 8.02944 22 13 22C17.9706 22 22 17.9706 22 13C22 8.02944 17.9706 4 13 4ZM9 13C9 15.2091 10.7909 17 13 17C15.2091 17 17 15.2091 17 13H19C19 16.3137 16.3137 19 13 19C9.68629 19 7 16.3137 7 13H9ZM10.5 10.5H8.5V8.5H10.5V10.5ZM17.5 10.5H15.5V8.5H17.5V10.5Z"
      fill="black"
    />
  </svg>
);

export const CoachArticlesIcon: SvgIcon = ({width = 26, height = 26}) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 26 26"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M19 7V9H7V7H19Z" fill="black" />
    <path d="M14 12V14H7V12H14Z" fill="black" />
    <path
      d="M22 6C22 4.39489 20.7394 3.08421 19.1543 3.00391L19 3H7C5.34315 3 4 4.34315 4 6V20L4.00391 20.1543C4.08421 21.7394 5.39489 23 7 23H19C20.6569 23 22 21.6569 22 20V6ZM24 20C24 22.7614 21.7614 25 19 25H7C4.32472 25 2.14053 22.8989 2.00684 20.2568L2 20V6C2 3.23858 4.23858 1 7 1H19L19.2568 1.00684C21.8989 1.14053 24 3.32472 24 6V20Z"
      fill="black"
    />
  </svg>
);

export const CoachInsightsIcon: SvgIcon = ({width = 26, height = 26}) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 26 26"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M17 25H9V23H17V25ZM13 1C17.9916 1 21.9999 5.13205 22 10.1816C22 12.9684 20.7808 15.4687 18.8535 17.1533L18.458 17.4795C18.1452 17.7234 18 18.0283 18 18.2881V21H16V18.2881C16 17.2812 16.5433 16.4361 17.2295 15.9014L17.5371 15.6475C19.0422 14.332 20 12.3749 20 10.1816C19.9999 6.19401 16.8449 3 13 3C9.15513 3 6.00009 6.19401 6 10.1816C6 12.4567 7.03067 14.4776 8.63379 15.792L8.77344 15.9121C9.45944 16.5273 9.99988 17.425 10 18.4873V21H8V18.4873C7.99989 18.1538 7.83629 17.7887 7.51367 17.4717L7.36621 17.3389C5.31257 15.6553 4 13.0728 4 10.1816C4.00009 5.13205 8.00843 1 13 1ZM17.707 8.70703L12 14.4141L8.79297 11.207L10.207 9.79297L12 11.5859L16.293 7.29297L17.707 8.70703Z"
      fill="black"
    />
  </svg>
);

export const CoachExercisesIcon: SvgIcon = ({width = 26, height = 26}) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 26 26"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M17.9148 12.9997C17.9147 9.76164 15.6534 6.94353 14.2292 5.49009C13.5991 4.84705 12.5957 4.84712 11.9655 5.49009C10.5413 6.94349 8.27907 9.76152 8.27894 12.9997L8.28577 13.3027C8.41994 16.4133 10.5858 19.1024 11.9655 20.5103C12.5562 21.1128 13.4745 21.1502 14.1062 20.6231L14.2292 20.5103C15.6089 19.1024 17.7748 16.4133 17.909 13.3027L17.9148 12.9997ZM19.9149 12.9997C19.9149 16.8356 17.4655 19.9961 15.9451 21.6152L15.655 21.9181C14.2853 23.3159 12.0953 23.3591 10.6745 22.0485L10.5397 21.9181C9.06604 20.4142 6.2789 17.0911 6.2789 12.9997C6.27903 8.9085 9.06607 5.58614 10.5397 4.08228L10.6745 3.95091C12.0494 2.68296 14.1443 2.6831 15.5193 3.95091L15.655 4.08228L15.9451 4.38522C17.4655 6.00434 19.9147 9.16412 19.9149 12.9997Z"
      fill="black"
    />
    <path
      d="M3.64809 6.74604L4.07095 6.75781C6.30477 6.84372 10.2667 7.37161 12.991 10.0597L13.0008 10.0695C13.0036 10.0667 13.0068 10.0644 13.0096 10.0617L13.2859 9.79989C16.1828 7.16951 20.2947 6.78373 22.3515 6.748L22.539 6.74898C24.4023 6.81113 25.9335 8.27486 25.998 10.1901L26 10.3832C25.9636 12.4249 25.5684 16.5061 22.8925 19.3752L22.6269 19.6487C19.721 22.516 15.4069 22.9254 13.284 22.9623C13.1698 22.9643 13.062 22.9598 12.9646 22.9525C12.8885 22.9568 12.8056 22.9609 12.7176 22.9594C10.6611 22.9237 6.54727 22.5383 3.65005 19.9075L3.37367 19.6457C0.639846 16.9481 0.0999959 13.0171 0.0122946 10.7999L0.000575693 10.3803C-0.0356029 8.30752 1.63827 6.71173 3.64809 6.74604ZM3.61294 8.75286C2.69929 8.73735 1.98397 9.44251 1.99963 10.344C2.03568 12.3676 2.45964 15.9284 4.77506 18.2134C7.09076 20.4982 10.6998 20.916 12.7508 20.9516L12.7166 22.9212L12.7176 22.9133L12.7508 20.9516C12.8314 20.9529 12.9109 20.9464 12.9881 20.9369C13.0304 20.9427 13.0736 20.9475 13.117 20.9506L13.2488 20.9545C15.2358 20.92 18.685 20.527 21.0038 18.4252L21.2245 18.2164C23.3953 16.0742 23.9035 12.8109 23.9882 10.744L24 10.3469C24.0158 9.44526 23.2995 8.73921 22.3857 8.75482C20.3348 8.79048 16.7265 9.20874 14.411 11.493L14.199 11.7116C13.7158 12.2306 13.3207 12.8068 12.9998 13.4106C12.679 12.8065 12.2847 12.2299 11.8015 11.7106L11.5886 11.491C9.27302 9.20642 5.66389 8.78849 3.61294 8.75286Z"
      fill="black"
    />
  </svg>
);

export const CoachWarningIcon: SvgIcon = ({
  width = 29,
  height = 29,
  classes = 'text-white',
}) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 29 23"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={classes}
  >
    <path
      d="M16.6725 2.88066L26.8141 17.203C28.1487 19.0878 26.7758 21.75 24.187 21.75H3.90389C1.31517 21.75 -0.0577999 19.0878 1.27682 17.203L11.4184 2.88066C12.6629 1.12311 15.428 1.12311 16.6725 2.88066Z"
      stroke="black"
      strokeWidth="1.5"
    />
    <path
      d="M13.5207 15.2934L13.1607 8.27344H15.3807L15.0057 15.2934H13.5207ZM14.2707 18.8784C13.9207 18.8784 13.6307 18.7634 13.4007 18.5334C13.1707 18.3034 13.0557 18.0284 13.0557 17.7084C13.0557 17.3884 13.1707 17.1184 13.4007 16.8984C13.6307 16.6684 13.9207 16.5534 14.2707 16.5534C14.6207 16.5534 14.9057 16.6684 15.1257 16.8984C15.3457 17.1184 15.4557 17.3884 15.4557 17.7084C15.4557 18.0284 15.3457 18.3034 15.1257 18.5334C14.9057 18.7634 14.6207 18.8784 14.2707 18.8784Z"
      fill="black"
    />
  </svg>
);

export const CoachPrivacyDataSecurityIcon: SvgIcon = ({
  width = 19,
  height = 22,
  classes = 'text-white',
}) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 19 22"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={classes}
  >
    <path
      d="M0.75 10.5C0.75 8.70507 2.20507 7.25 4 7.25H15C16.7949 7.25 18.25 8.70507 18.25 10.5V17.5C18.25 19.2949 16.7949 20.75 15 20.75H4C2.20507 20.75 0.75 19.2949 0.75 17.5V10.5Z"
      stroke="black"
      strokeWidth="1.5"
    />
    <path
      d="M9.5 11V16"
      stroke="black"
      strokeWidth="1.5"
      strokeLinecap="round"
    />
    <path
      d="M15 7.5V4.5C15 2.84315 13.6569 1.5 12 1.5H7C5.34315 1.5 4 2.84315 4 4.5V7.5"
      stroke="black"
      strokeWidth="1.5"
    />
  </svg>
);

export const CoachConsentIcon: SvgIcon = ({
  width = 17,
  height = 21,
  classes = 'text-white',
}) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 17 21"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={classes}
  >
    <path
      d="M1.25 4.5C1.25 2.70507 2.70507 1.25 4.5 1.25H12.5C14.2949 1.25 15.75 2.70507 15.75 4.5V16.5C15.75 18.2949 14.2949 19.75 12.5 19.75H4.5C2.70507 19.75 1.25 18.2949 1.25 16.5V4.5Z"
      stroke="black"
      strokeWidth="1.5"
    />
    <path d="M5 6H12" stroke="black" strokeWidth="1.5" strokeLinecap="round" />
    <path d="M5 9H12" stroke="black" strokeWidth="1.5" strokeLinecap="round" />
    <path d="M5 12H12" stroke="black" strokeWidth="1.5" strokeLinecap="round" />
    <path d="M5 15H9" stroke="black" strokeWidth="1.5" strokeLinecap="round" />
  </svg>
);
